const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Raghvendra</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate VFX Head, UPES-CSI</li>
    <li>
        Skilled in visual effects and animation.
    </li>
    <li>
        Creating impactful visual content.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
